import React from 'react';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
import Login from './login';
import { getTokenWithExpiry, setToken, deleteToken } from '../services/authentication';
import HealthLoader from './health-loader';
import { IS_DEVELOPMENT } from '../services/config';
import { classes } from './styles';
import { Provider } from '../services/collection';
import App from './app';
import { wrapPermissionsProvider } from '../services/permissions';
import PermissionsLoader from './permissions-loader';

class AppWrapper extends React.Component {

  history = createBrowserHistory();

  state = {
    authToken: null
  };

  constructor(props) {
    super(props);

    const tokenAndExpiry = getTokenWithExpiry();
    if (tokenAndExpiry) {
      const { token, expiresAt } = tokenAndExpiry;
      if (expiresAt > Date.now()) {
        this.state.authToken = token;
        this.onAuthenticatedTimeout(expiresAt);
      }
    }
  }

  componentDidMount() {
    this.correctUrl();
  }

  componentWillUnmount() {
    if (this.unauthenticateTimeout) {
      clearTimeout(this.unauthenticateTimeout);
    }
  }

  onLogout = () => {
    this.setState({
      authToken: null
    }, () => {
      deleteToken();
    });
  };

  componentDidUpdate() {
    this.correctUrl();
  }

  correctUrl() {
    if (!this.state.authToken && this.history.location.pathname !== '/login') {
      this.history.push('/login');
    }
  }

  onAuthenticatedTimeout = (expiresAt) => {
    if (this.unauthenticateTimeout) {
      clearTimeout(this.unauthenticateTimeout);
    }
    if (!this.state.authToken) {
      return;
    }
    if (typeof expiresAt !== 'number') {
      return;
    }
    this.unauthenticateTimeout = setTimeout(
      () => {
        this.setState({
          authToken: null
        })
      },
      Math.max(0, expiresAt - Date.now())
    );
  };

  onAuthenticated = (token, expiresAt) => {
    this.setState({
      authToken: token
    }, () => {
      this.onAuthenticatedTimeout(expiresAt);
      setToken(token);
    });
  };

  render() {
    const component = this.state.authToken ? this.renderAuthenticated() : this.renderLogin();
    return (
      <React.Fragment>
        {component}
        {
          IS_DEVELOPMENT ? (
              <p style={{ position: 'absolute', bottom: 13, left: 9, fontSize: 'small' }}>Development version</p>
            ) : null
        }
      </React.Fragment>
    )
  }

  renderAuthenticated() {
    return (
      <div className={classes.root}>
        <HealthLoader>
          {() => {
            const Component = wrapPermissionsProvider(
              () => (
                <PermissionsLoader>
                  {
                    () => (
                      <Router history={this.history}>
                        <App
                          onLogout={this.onLogout}
                        />
                      </Router>
                    )
                  }
                </PermissionsLoader>
              )
            );
            return (
              <Provider>
                <Component />
              </Provider>
            )
          }}
        </HealthLoader>
      </div>
    )
  }

  renderLogin() {
    return <Login onAuthenticated={this.onAuthenticated} />
  }

}

export default AppWrapper;



// WEBPACK FOOTER //
// ./src/app/index.js